import Vue from 'vue';

import App from './App.vue';
import router from './router';
import store from '../src/store';
import './plugins/axios';
import '@/plugins/vuelidate.js';
import VueHtmlToPaper from 'vue-html-to-paper';
import moment from 'moment';

import VModal from 'vue-js-modal/dist/index.nocss.js';
import 'vue-js-modal/dist/styles.css';
Vue.use(VModal);

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);

import SkeletonCards from 'vue-ultimate-skeleton-cards';
Vue.use(SkeletonCards);

import VTooltip from 'v-tooltip';
Vue.use(VTooltip);

import ScrollLoader from 'vue-scroll-loader';
Vue.use(ScrollLoader);

import VueSimpleAlert from 'vue-simple-alert';
Vue.use(VueSimpleAlert, {reverseButtons: true});

Vue.config.productionTip = false;
Vue.prototype.$log = console.log;
const options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
  ],
};

Vue.use(VueHtmlToPaper, options);

// or, using the defaults with no stylesheet
Vue.use(VueHtmlToPaper);

// import "@/assets/css/bootstrap.min.css";
import '@/assets/css/bootstrap_customized.min.css';
import '@/assets/css/style.css';
import '@/assets/css/listing.css';
import '@/assets/css/custom.css';
import '@/assets/css/booking-sign_up.css';
import '@/assets/css/detail-page.css';
import '@/assets/css/booking-sign_up.css';
import '@/assets/css/home.css';
import '@/assets/css/help.css';
import '@/assets/css/booking-sign_up.css';
import '@/assets/css/submit.css';
import '@/assets/css/tooltip.css';
import '@/assets/css/media_queries.css';
import '@/assets/css/detail-page.css';
import '@/assets/css/review.css';
import '@/assets/css/theme-gnanams.css';
import '@/assets/css/kot-datepicker.css';
import '@/assets/css/kot-dark.css';
import { applyKotTheme } from '@/utils/kotTheme';
import { initKotDark } from '@/utils/kotDarkMode';
import { bootPwa } from '@/utils/pwa';

applyKotTheme();
initKotDark();
bootPwa();

// import "@/assets/css/main.css";

import {BadgerAccordion, BadgerAccordionItem} from 'vue-badger-accordion';
Vue.component('BadgerAccordion', BadgerAccordion);
Vue.component('BadgerAccordionItem', BadgerAccordionItem);
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY');
  }
});
Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).format('HH:mm');
  }
});
Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).format('HH:mm');
  }
});
Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss');
  }
});
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
